// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"style-module_toggleContainer__2suiQL9vDrUkNUTQFNC9u-"};